<template>
  <div class="page-container">
    <ModalMatriculas :showDialog="modalMatriculaVisible" @click="selecionaRa" @closed="modalMatriculaVisible = false" />
    <md-app>
      <md-app-toolbar id="top-menu" class="md-dense" md-elevation="1">
        <md-button class="md-icon-button" @click="toggleMenu" v-if="!menuVisible">
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-title">
          Integra
        </span>

        <div class="md-toolbar-section-end">
          <md-button class="md-outlined md-dense md-primary" @click="tabulacao()">
            Tabulação
          </md-button>
          <md-button class="md-raised md-dense md-primary" @click="concluirAtendimento">
            Concluir Atendimento
          </md-button>

          <md-menu md-size="medium" md-align-trigger v-if="user">
            <md-button md-menu-trigger>
              <md-avatar v-if="user.fotoUrl" class="md-small">
                <img :src="user.fotoUrl" alt="Avatar">
              </md-avatar>
              <md-avatar v-else class="md-avatar-icon md-small">
                <md-icon>person</md-icon>
              </md-avatar>
              {{user.shortName}}
            </md-button>

            <md-menu-content>
              <md-menu-item v-on:click="logout">
                <span class="s-h3">Sair</span>
                <md-icon>exit_to_app</md-icon>
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>
      </md-app-toolbar>

      <md-app-drawer id="sidebar" :md-active.sync="menuVisible" md-persistent="mini" style="z-index: 5;">
        <md-card md-with-hover v-show="menuVisible" id="sidebar-card-header">
          <md-ripple>
            <div @click="navegaPerfilAluno">
              <md-toolbar class="md-transparent md-dense toolbar-aluno" md-elevation="0">
                <span>
                  <md-icon>face</md-icon><span class="nome-aluno s-h2">{{Aluno.shortName}}</span>
                </span>
              </md-toolbar>

              <md-list>
                  <md-list-item class="ra">
                      <md-icon>local_library</md-icon>
                      <span class="ra-label">RA</span>

                      <div class="md-list-item-text">
                          <span class="ra-info">{{Aluno.codigoAluno}}{{Aluno.codigoEspecialidade}}</span>
                      </div>
                  </md-list-item>

                  <md-list-item>
                      <div class="md-list-item-text s-h3">
                          <span><LabelSituacaoAcademica :codigo="Aluno.codigoSituacaoAtual" :descricao="Aluno.situacaoAtual" /></span>
                      </div>
                  </md-list-item>
                  <!--
                    <div class="link-perfil">
                    Perfil do Aluno
                    </div>
                  -->
              </md-list>
            </div>
          </md-ripple>
        </md-card>

        <md-list id="sidebar-menu">
            <md-list-item md-expand :md-expanded="true" class="agrupador">
                <span class="titulo s-h4">Financeiro</span>
                <!--<span class="md-list-item-text" v-show="!menuVisible"><strong>Financeiro</strong></span>-->
                <md-list slot="md-expand" class="menu" :md-expand-single="true">
                  <md-list-item md-expand :md-expanded.sync="expandMensalidade" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_MENSALIDADE">
                    <md-icon>attach_money</md-icon>
                    <span class="md-list-item-text s-h2">Mensalidades</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Mensalidades</md-tooltip>
                    <md-list slot="md-expand" class="submenu">
                      <md-list-item to="/mensalidadesativos" v-if="$featureToggle.INTEGRA_MENSALIDADES_ATIVOS">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Ativos</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Ativos</md-tooltip>
                      </md-list-item>
                      <md-list-item to="/mensalidadescancelados" v-if="$featureToggle.INTEGRA_MENSALIDADES_CANCELADOS">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Canceladas</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Canceladas</md-tooltip>
                      </md-list-item>
                      <md-list-item to="/mensalidadesvalorbruto" v-if="$featureToggle.INTEGRA_MENSALIDADES_VALORBRUTO">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Valor Bruto</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Valor Bruto</md-tooltip>
                      </md-list-item>
                      <md-list-item to="/mensalidadescashback" v-if="$featureToggle.INTEGRA_MENSALIDADES_CASHBACK">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Cashback</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Cashback</md-tooltip>
                      </md-list-item>
                    </md-list>
                  </md-list-item>
                  <md-list-item md-expand :md-expanded.sync="expandServico" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_SERVICOS">
                    <md-icon>build</md-icon>
                    <span class="md-list-item-text s-h2">Serviços</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Serviços</md-tooltip>
                    <md-list slot="md-expand" class="submenu">
                      <md-list-item to="/servicoAtivo" v-if="$featureToggle.INTEGRA_SERVICOS_ATIVOS">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Ativos</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Ativos</md-tooltip>
                      </md-list-item>
                      <md-list-item to="/servicoCancelado" v-if="$featureToggle.INTEGRA_SERVICOS_CANCELADOS">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Cancelados</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Cancelados</md-tooltip>
                      </md-list-item>
                    </md-list>
                  </md-list-item>
                  <md-list-item to="/creditos" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_CREDITOS">
                    <md-icon>monetization_on</md-icon>
                    <span class="md-list-item-text s-h2">Créditos</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Créditos</md-tooltip>
                  </md-list-item>
                  <md-list-item md-expand :md-expanded.sync="expandBeneficio" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_BENEFICIOS">
                    <md-icon>star</md-icon>
                    <span class="md-list-item-text s-h2">Beneficios</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Beneficios</md-tooltip>
                    <md-list slot="md-expand" class="submenu">
                      <md-list-item to="/beneficioAtivo" v-if="$featureToggle.INTEGRA_MENU_BENEFICIOS_ATIVO">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Ativos</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Ativos</md-tooltip>
                      </md-list-item>
                      <md-list-item to="/beneficioExcluido" v-if="$featureToggle.INTEGRA_MENU_BENEFICIOS_EXCLUIDO">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Excluídos</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Excluídos</md-tooltip>
                      </md-list-item>
                      <md-list-item to="/beneficioHistorico" v-if="$featureToggle.INTEGRA_MENU_BENEFICIOS_HISTORICO">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Histórico</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Histórico</md-tooltip>
                      </md-list-item>
                    </md-list>
                  </md-list-item>
                  <md-list-item to="/carneAtivo" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_CARNE_ATIVO">
                    <md-icon>receipt</md-icon>
                    <span class="md-list-item-text s-h2">Carnês</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Carnês</md-tooltip>
                  </md-list-item>
                  <md-list-item to="/francesinha" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_FRANCESINHA">
                    <md-icon>search</md-icon>
                    <span class="md-list-item-text s-h2">Francesinha</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Francesinha</md-tooltip>
                  </md-list-item>
                  <md-list-item md-expand :md-expanded.sync="expandFies" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_FIES">
                    <md-icon>account_balance</md-icon>
                    <span class="md-list-item-text s-h2">Fies</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Fies</md-tooltip>
                    <md-list slot="md-expand" class="submenu">
                      <md-list-item to="/baseanaliticafies" v-if="$featureToggle.INTEGRA_MENU_FIES_ANALITICO">
                        <span class="md-list-item-text s-h3 open">Analítico</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Analítico</md-tooltip>
                      </md-list-item>
                      <md-list-item to="/fiesAditamento" v-if="$featureToggle.INTEGRA_MENU_FIES_BASEFULL">
                        <span class="md-list-item-text s-h3 open">Aditamento</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Aditamento</md-tooltip>
                      </md-list-item>
                    </md-list>
                  </md-list-item>
                  <md-list-item to="/prouni" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_PROUNI">
                    <md-icon>account_balance_wallet</md-icon>
                    <span class="md-list-item-text s-h2">PROUNI</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">PROUNI</md-tooltip>
                  </md-list-item>
                  <md-list-item md-expand :md-expanded.sync="expandPam" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_PAM">
                    <md-icon>add_box</md-icon>
                    <span class="md-list-item-text s-h2">PAM</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">PAM</md-tooltip>
                    <md-list slot="md-expand" class="submenu">
                      <md-list-item to="/pamRecalculo" v-if="$featureToggle.INTEGRA_MENU_PAM_RECALCULO">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Recálculo</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Recálculo</md-tooltip>
                      </md-list-item>
                      <md-list-item to="/pamTrocaTurma" v-if="$featureToggle.INTEGRA_MENU_PAM_TROCATURMA">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Troca de Turma</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Troca de Turma</md-tooltip>
                      </md-list-item>
                    </md-list>
                  </md-list-item>
                  <md-list-item to="/acordo" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_ACORDO">
                    <md-icon>request_quote</md-icon>
                    <span class="md-list-item-text s-h2">Acordo</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Acordo</md-tooltip>
                  </md-list-item>
                  <md-list-item to="/termoscontrato" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_CONTRATO">
                    <md-icon>description</md-icon>
                    <span class="md-list-item-text s-h2">Termos e Contratos</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Termos e Contratos</md-tooltip>
                  </md-list-item>
                  <md-list-item to="/raid" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_RAID && raidRole">
                    <md-icon>backup_table</md-icon>
                    <span class="md-list-item-text s-h2">RAID</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">RAID</md-tooltip>
                  </md-list-item>
                </md-list>
            </md-list-item>

            <md-list-item md-expand :md-expanded="true" class="agrupador">
                <span class="titulo s-h4 s-h4">Acadêmico</span>
                <!--<span class="md-list-item-text" v-show="!menuVisible"><strong>Acadêmico</strong></span>-->
                <md-list slot="md-expand" class="menu" :md-expand-single="true">
                  <md-list-item md-expand :md-expanded.sync="expandQuadroHorario" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_QUADROHORARIO">
                    <md-icon>account_balance</md-icon>
                    <span class="md-list-item-text s-h2">Quadro de Horário</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Quadro de Horário</md-tooltip>
                    <md-list slot="md-expand" class="submenu">
                      <md-list-item to="/quadroHorarioSalaNormal" v-if="$featureToggle.INTEGRA_MENU_QUADROHORARIO_SALANORMAL">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Sala Normal</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Sala Normal</md-tooltip>
                      </md-list-item>
                      <md-list-item to="/quadroHorarioSalaEspecial" v-if="$featureToggle.INTEGRA_MENU_QUADROHORARIO_SALAESPECIAL">
                        <md-icon>fiber_manual_record</md-icon>
                        <span class="md-list-item-text s-h3 open">Sala Especial</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Sala Especial</md-tooltip>
                      </md-list-item>
                    </md-list>
                  </md-list-item>
                  <md-list-item to="/trocaturma" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_TROCATURMA">
                    <md-icon>swap_vertical_circle</md-icon>
                    <span class="md-list-item-text s-h2">Troca Turma</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Troca Turma</md-tooltip>
                  </md-list-item>
                  <md-list-item to="/situacaoacademica" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_SITUACAO_ACADEMICA">
                    <md-icon>local_library</md-icon>
                    <span class="md-list-item-text s-h2">Situação Acadêmica</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Situação Acadêmica</md-tooltip>
                  </md-list-item>
                  <md-list-item to="/historicoescolar" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_HISTORICO_ESCOLAR">
                    <md-icon>class</md-icon>
                    <span class="md-list-item-text s-h2">Histórico Escolar</span>
                    <md-tooltip v-show="!menuVisible" md-direction="right">Histórico Escolar</md-tooltip>
                  </md-list-item>
                </md-list>
            </md-list-item>

            <md-list-item md-expand :md-expanded="true" class="agrupador">
                <span class="titulo s-h4">Atendimento</span>
                <md-list slot="md-expand" class="menu" :md-expand-single="true">
                    <md-list-item to="/aluno" v-if="$featureToggle">
                        <md-icon>person</md-icon>
                        <span class="md-list-item-text s-h2 s-h2">Perfil do Aluno</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Perfil do Aluno</md-tooltip>
                    </md-list-item>
                    <md-list-item to="/chamado" v-if="$featureToggle && $featureToggle.INTEGRA_MENU_CHAMADO">
                        <md-icon>chat</md-icon>
                        <span class="md-list-item-text s-h2 s-h2">Chamados</span>
                        <md-tooltip v-show="!menuVisible" md-direction="right">Chamados</md-tooltip>
                    </md-list-item>
                </md-list>
            </md-list-item>
        </md-list>
      </md-app-drawer>

      <md-app-content id="content">
        <div v-if="!menuVisible && $route.name != 'Aluno'">
          <md-list id="header-info">
            <md-list-item>
              <!--<md-icon class="md-primary">face</md-icon>-->
              <div class="md-list-item-text">
                <p class="fontsize15">{{Aluno.shortName}}</p>
                <LabelSituacaoAcademica :codigo="Aluno.codigoSituacaoAtual" :descricao="Aluno.situacaoAtual" />
              </div>
            </md-list-item>

            <md-list-item>

              <div class="md-list-item-text">
                <p class="fontsize15">CPF {{Aluno.cpf}}</p>
                <p class="infoLinhaInferior fontsize15">RA {{Aluno.codigoAluno}}{{Aluno.codigoEspecialidade}}</p>

              </div>
            </md-list-item>

            <md-list-item>
              <div class="md-list-item-text">
                <p class="fontsize15">{{Aluno.telefone}}</p>
                <p class="infoLinhaInferior fontsize15">{{Aluno.codigoEspecialidade}} - {{Aluno.descricaoEspecialidade}}</p>
              </div>
            </md-list-item>

            <md-list-item>
              <div class="md-list-item-text">
                <p class="fontsize15">{{Aluno.email}}</p>
                <p class="infoLinhaInferior fontsize15">{{Aluno.codigoTurma}} - NFT:{{Aluno.situacaoNftTurma}} - {{Aluno.etapaAtualTurma}}º Semestre </p>
              </div>
            </md-list-item>

            <md-list-item>
              <md-button to="/aluno" class="md-primary">Ver mais</md-button>
            </md-list-item>
          </md-list>
          <hr />
        </div>
        <Loading v-if="showLoading != 'undefined'" v-bind:show="showLoading">
          <slot />
        </Loading>
      </md-app-content>

    </md-app>
  </div>
</template>

<script>
  import Loading from '@/components/Loading';
  import LabelSituacaoAcademica from '@/components/LabelSituacaoAcademica.vue';
  import ModalMatriculas from '@/components/ModalMatriculas.vue';
  import PerfilAluno from '@/services/PerfilAlunoService.js';

  export default {
    components: {
      Loading,
      LabelSituacaoAcademica,
      ModalMatriculas
    },

    data: () => ({
      showLoading: false,
      menuVisible: (sessionStorage.menuVisibleSaved ? sessionStorage.menuVisibleSaved == 'true' : true),
      menuAtivo: 'FIN',
      modalMatriculaVisible: false,
      Aluno: {},
      Situacao: {},
      tooltipActive: false,
      expandAcademico: true,
      expandFinanceiro: true,
      expandMensalidade: false,
      expandServico: false,
      expandBeneficio: false,
      expandCredito: false,
      expandCarne: false,
      expandPam: false,
      expandFies: false,
      expandProUni: false,
      expandQuadroHorario: false
    }),

    computed: {
      user() {
        let user = null;
        if (this.msal.isAuthenticated) { // Note that the dollar sign ($) is missing from this.msal
          user = {
            ...this.msal.user,
            profile: {}
          }

          if (this.msal.graph && this.msal.graph.profile) {
            user.profile = this.msal.graph.profile;

            if (this.msal.graph.photo) {
              user.fotoUrl = URL.createObjectURL(this.msal.graph.photo);
            }
          }

          //Split do Nome
          let nameSplited = user.name?.split(' ');
          if (nameSplited.length > 2) {
            user.shortName = nameSplited[0] + ' ' + nameSplited[nameSplited.length - 1];
          }
          else
            user.shortName = user.name;
        }

        return user;
        },
        raidRole() {
            if (this.msal.isAuthenticated && this.msal?.user?.idTokenClaims?.roles?.length) {
                return this.msal.user.idTokenClaims.roles.includes("RAID_Acessar")
            } else {
                console.log("Running Computed RAID Role with response FALSE")
                return false
            }
        }
    },
    created() {
      //Verifica se tem aluno selecionado
      if (!sessionStorage.Aluno) {
        this.$router.push('home');
      }
      else {
        let aluno = JSON.parse(sessionStorage.Aluno);
        if (aluno.PerfilAluno)
          this.Aluno = aluno.PerfilAluno;
        else
          this.$router.push('home');
      }

      //ShortNome
      let nameSplited = this.Aluno.nomeAluno.split(' ');
      if (nameSplited.length > 2) {
        this.Aluno.shortName = nameSplited[0] + ' ' + nameSplited[nameSplited.length - 1];
      }
      else
        this.Aluno.shortName = this.Aluno.nomeAluno;

      this.perfilAlunoService = new PerfilAluno(this);
    },

    methods: {
      concluirAtendimento() {
        window.close();
      },

      tabulacao() {
        window.location = this.$Configs.urlServiceNow + "pad?id=sc_category&catalog_id=-1&codigoAluno=" + this.Aluno.codigoAluno + "&codigoEspecialidade=" + this.Aluno.codigoEspecialidade + "&header=false";
      },

      toggleMenu(event) {
        this.menuVisible = !this.menuVisible;
        sessionStorage.menuVisibleSaved = this.menuVisible;

        event.stopPropagation();
      },

      navegaPerfilAluno() {
        if (this.$route.name != 'Aluno')
          this.$router.push('aluno');
      },

      alternarRa() {
        this.modalMatriculaVisible = true;
      },

      selecionaRa(aluno) {
        this.modalMatriculaVisible = false;

        //Popula os dados da aba
        this.showLoading = true;
        this.perfilAlunoService.RetornaDadosAluno({ CodigoAluno: aluno.codigoAluno, codigoEspecialidade: aluno.codigoEspecialidade }).then(
          data => {
            if (data.ok) {
              aluno.PerfilAluno = data.dados;
              sessionStorage.Aluno = JSON.stringify(aluno);

              window.location.reload();
            }
            else {
              this.showLoading = false;
              this.$modal.info(data.Mensagem);
            }
          },
          error => {
            this.showLoading = false;

            if (error.status != 500)
              this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
            else
              this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
          });
      },

      logout() {
        this.$msal.signOut();
      }
    }
  }
</script>

<style scoped>
  .md-app {
    min-height: 350px;
    height: -webkit-fill-available;
    border: 1px solid rgba(#000, .12);
  }

    .md-list-item-text {
        font-family: 'Roboto', 'Open Sans', Verdana, sans-serif
    }

    .md-drawer {
        width: 230px;
        max-width: calc(100vw - 125px);
    }

    .md-drawer:not(.md-active) {
      transform: translate3D(0,49px,0) !important;
    }
</style>

<style>
  .infoLinhaInferior {
    margin-top: 5px;
  }

  .fontsize15 {
    font-size: 15px !important;
  }
</style>